import React from 'react';
import AttendanceManagement from './AttendanceManagement';

/**
 * Wrapper that renders AttendanceManagement restricted to courses the current user (instructor) teaches.
 */
const InstructorAttendance = () => (
  <AttendanceManagement filterByInstructorId useInstructorTradeScope />
);

export default InstructorAttendance;
